import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoteMentionBroadcastIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M3 11L21 6V18L3 13V11Z M11.6 16.8C11.8 17.9 11.1 18.9 10 19.2C8.9 19.4 7.8 18.7 7.6 17.6L7 15.2",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgNoteMentionBroadcastIcon);
export default ForwardRef;
